// react
import React, { useContext, useEffect } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { ResponsivePie } from '@nivo/pie'
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import logoEmagrecentro from 'assets/img/emagrecentro.png';
import logoDM2 from 'assets/img/Logo_DM2.png';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search_Icon from "@material-ui/icons/Search";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { Pie } from "@nivo/pie";
import { ThemeProvider, SvgWrapper } from "@nivo/core";
import { BoxLegendSvg } from "@nivo/legends";

import PieChart from "@material-ui/icons/PieChart";
// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { List, TableFooter } from '@material-ui/core';

const useStyles = makeStyles(styles);

export default function RelatorioRankingFaturamento() {
    // Padrão para Todas as Telas
    const { t } = useTranslation();

    useEffect(() => {
        sendScrollToTOP();
    }, []);

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });

    // Elementos de LayOut
    const classes = useStyles();
    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };
    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const [dataCSV, set_dataCSV] = React.useState([]);

    // Filtros
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-1, 'months')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() +
            (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    // Ações 
    const handleClickPesquisa = () => {
        let data = getValues();

        if (data.dtini === "") {
            setError("dtini", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")

        if (data.dtfim === "") {
            setError("dtfim", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")

        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")

        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);

        let obj = {
            franquiaId: session.franquiaId,
            dataIni: dataIniConvertida,
            dataFim: dataFimConvertida
        }

        loadDados(obj);
    };

    const loadDados = (obj) => {
        setisLoadingList(true);
        const endPoint = "relatorios/rankingFaturamento";
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false;
            }

            setlist(result.data);

            let dataCSV = [];

            result.data.map(item => {
                var obj = {
                    estabelecimentoDescricao: item.estabelecimentoDescricao,
                    cidade: item.cidade,
                    bairro: item.bairro,
                    estado: item.estado,
                    valor: "R$" + (item.valor).toFixed(2).replace('.', ',')
                };
                dataCSV.push(obj);
            })

            setTimeout(() => { set_dataCSV(dataCSV); }, (1000));

            setisLoadingList(false);
            return true;
        });
    }
    // *******************************************************************************
    // *************************** PROPRIEDADES CABEÇALHO ****************************
    // *******************************************************************************

    const StyledTableCell = withStyles((theme) => ({
        head: {
            color: theme.palette.common.white,
            background: 'linear-gradient(60deg, #562682, #408199)'
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    function createData(estabelecimentoDescricao, cidade, bairro, estado, valor) {
        return { estabelecimentoDescricao, cidade, bairro, estado, valor };
    }

    //   const columnsProp = [
    //     {
    //         Header: t('label.clinic'),
    //         filterable: false,
    //         accessor: "estabelecimentoDescricao",        
    //     },
    //     {
    //         Header: t('label.city'),
    //         filterable: false,
    //         accessor: "cidade",        
    //     },
    //     {
    //         Header:t('label.neighborhood'),
    //         filterable: false,
    //         accessor: "bairro"
    //     },
    //     {
    //         Header:t('label.state'),
    //         filterable: false,
    //         accessor: "estado"
    //     },
    //     {
    //         Header:'Ranking',
    //         filterable: false,
    //         accessor: "valor"
    //     }
    //     ];
    const columns = [{
        id: 'estabelecimentoDescricao',
        displayName: "Estabelecimento"
    }, {
        id: 'cidade',
        displayName: "Cidade"
    },
    {
        id: 'bairro',
        displayName: "Bairro"
    },
    {
        id: 'estado',
        displayName: "UF"
    },
    {
        id: 'valor',
        displayName: "Ranking"
    },

    ];

    const DataAtual = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear() + ' - ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    }

    return (

        <div>

            {/* PESQUISA */}
            <GridContainer className="no-print">
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Search_Icon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('label.research')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                                            {t('label.ini_date') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtini"
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtini ? "error" : ""}
                                        />
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                                            {t('label.end_date') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtfim"
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtfim ? "error" : ""}
                                        />
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button round color="primary"
                                        onClick={e => { handleClickPesquisa() }}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>

                                {notification.show &&
                                    <div><br />
                                        <SnackbarContent
                                            message={notification.message}
                                            color={notification.color}
                                            closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                            close
                                        /></div>}
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* LISTA VENDA */}
            <GridContainer >
                <GridItem md={12} xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={`${classes.cardIconTitle} tituloPrint`}>
                                {t('sidebar.resume_ranking')}
                            </h4>
                        </CardHeader>
                        <CardBody>

                            <TableContainer >
                                <div className='text-right'>
                                    <div style={{ display: 'inline-block' }} >
                                        <CsvDownloader filename="RankingFaturamento" columns={columns} datas={dataCSV} separator={";"}>
                                            <Button round color="default" className="no-print">CSV</Button>
                                        </CsvDownloader>
                                    </div>
                                    {/* <Button className="no-print" round color="primary" onClick={() => window.print()}> {t('button.print')} </Button> */}
                                </div>
                                <div className="allowPrint">
                                    <div className="cabecalho-print">
                                        <div style={{ maxWidth: '200px', display: 'inline-block', float: 'left' }}>
                                            {
                                                session.franquiaId === 1 ? (
                                                    <img src={logoEmagrecentro} style={{ maxWidth: '200px' }} />
                                                ) : session.franquiaId === 3 ? (
                                                    <img src={logoDM2} style={{ maxWidth: '200px' }} />
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                        {/* <div style={{display:'inline-block',float: 'right'}}>
                                            <p style={{margin:0}}>Filtros: </p>
                                            <h6 style={{margin:0}}>Inicio: {dataIniImpressao} | Fim: {dataFimImpressao} </h6>
                                        </div> */}
                                    </div>
                                    <hr className="cabecalho-print line" />
                                    <p className="cabecalho-print" style={{ float: "left" }}>Emitido por: {session.nome}  - {DataAtual}</p>
                                    {<Table className={classes.table} aria-label="customized table">
                                        <TableHead className="cabecalho-tabela">
                                            <TableRow>
                                                <StyledTableCell align="left">{t('label.clinic')}</StyledTableCell>
                                                <StyledTableCell align="left">{t('label.city')}</StyledTableCell>
                                                <StyledTableCell align="left">{t('label.neighborhood')}</StyledTableCell>
                                                <StyledTableCell align="left">{t('label.state')}</StyledTableCell>
                                                <StyledTableCell align="right">Ranking</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {list.map((row) => (

                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell align="left">{row.estabelecimentoDescricao}</StyledTableCell>
                                                    <StyledTableCell align="left">{row.cidade}</StyledTableCell>
                                                    <StyledTableCell align="left">{row.bairro}</StyledTableCell>
                                                    <StyledTableCell align="left">{row.estado}</StyledTableCell>
                                                    <StyledTableCell align="right">{"R$ " + (row.valor).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                </StyledTableRow>

                                            ))
                                            }

                                        </TableBody>

                                    </Table>}
                                    {/* <div className="allowPrint-table">
                                            <ReactTable className={classes.table} aria-label="customized table"                 
                                                    loading = {isLoadingList}
                                                    data={list}
                                                    columns={columnsProp}                                                  
                                                    style={{height: "400px"}}
                                                    showPagination={false}
                                                    pageSize={dataCSV.length}
                                                    minRows={5}
                                                    className="-striped -highlight"
                                                    previousText={t('button.previous')}
                                                    nextText={t('button.next')}
                                                    loadingText={t('label.loading')+"..."}
                                                    noDataText={t('information_message.no_records_found')+"!"}
                                                    pageText={t('label.page')}
                                                    ofText={t('label.of')}
                                                    rowsText={t('label.rows')}
                                                />
                                        </div> */}
                                </div>

                            </TableContainer>

                        </CardBody>

                    </Card>
                </GridItem>
            </GridContainer>
        </div>

    );

}